/**
 * Encoding conversion table for JIS to UTF-8
 */
var JIS_TO_UTF8_TABLE = null;
module.exports = JIS_TO_UTF8_TABLE;



//////////////////
// WEBPACK FOOTER
// ./node_modules/encoding-japanese/src/jis-to-utf8-table.js
// module id = 1164
// module chunks = 1